module.exports = __webpack_public_path__ + "media/images/icons/icon-pack-9e64be8fcef1e74dbcdeb1d3ece29fc4.svg";